<template>
   <el-tabs type="border-card">
        <el-tab-pane label="产品编辑">
            <div style="margin-top:16px;" >
                <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item label="汇率名称">
                        <el-input v-model.trim="form.name" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="最新汇率">
                        <el-input v-model.trim="form.rate" placeholder="汇率原固定汇率" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="当前税金">
                        <el-input v-model.trim="form.realTax" placeholder="当前税金"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">立即编辑</el-button>
                        <el-button @click="onCancel">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-tab-pane>
    </el-tabs>
</template>
<script>
  export default {
    data() {
      return {
        display: false,
        form: {
          id: '',
          name: '',
          realRate: '',
          rate: '',
          realTax: '',
          tax: '',
          stockState: '',
          token: this.user.getToken()
        },
      }
    },

    methods: {
      onSubmit() {
        // 初始化默认加载菜单
        this.http.post(
          '/shopConfigExchange/editor', 
          this.form, res => {
            if (res.success) {
              // 返回正确的处理
              this.$router.push("/exchangeConfig/list")
            } else {
              // 返回错误的处理
              this.$message.error(res.message)
            }
        });
      },
      onCancel() {
          this.$router.go(-1)
      }
    },
    mounted() {
      this.form = this.$route.params
    }
  }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/views/system/exchange/exchangeConfigEditor.vue